import { render, staticRenderFns } from "./layout-chat-info.vue?vue&type=template&id=ebe13f2c&"
import script from "./layout-chat-info.vue?vue&type=script&lang=js&"
export * from "./layout-chat-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports